import { Center } from '@chakra-ui/react'
import {
	CalendarDate,
	getDayOfWeek,
	parseAbsolute,
} from '@internationalized/date'
import Color from 'color'

import { CALENDER_QUERIES } from '../../Calendar/styles/responsive'
import { useSchedulerContext } from '..'

const getColorByIndex = (baseColor: string, index: number) => {
	const fade = 0.8 + ((index * 13) % 14) / 100
	return Color(baseColor).fade(fade).hexa()
}

export const CalendarCellLoading = ({
	index,
	date,
}: {
	index: number
	date: CalendarDate
}) => {
	const { styles, timezone, locale } = useSchedulerContext()

	const dayOfWeek = getDayOfWeek(date, locale)
	const isSaturday = dayOfWeek === 6
	const isSunday = dayOfWeek === 0

	const today = parseAbsolute(new Date().toISOString(), timezone)
	const isBeforeToday = date.compare(today) < 0
	const isInactive = isBeforeToday || isSaturday || isSunday

	const inactiveColor = Color(styles.text_primary).fade(0.95).hexa()
	const baseColor = getColorByIndex(styles.text_primary, index)

	return (
		<Center
			h="45px"
			w="45px"
			bg={isInactive ? inactiveColor : baseColor}
			borderRadius="full"
			sx={{
				[CALENDER_QUERIES.xs]: {
					w: '36px',
					h: '36px',
				},
			}}
		/>
	)
}
